<template>
  <div>
		<Layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center">
              <h1>{{ $t('payment.unpaid_payment_list') }}</h1>
            </v-col>
            <v-col cols="12" class="text-center pt-5 grey lighten-4">
              <div class="text-end">
                <v-btn @click="exportExcel()" class="blue white--text" :disabled="isLoading">
                  <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                  Export Excel
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-data-table
          v-if="!isLoading"
          :headers="dataTable.header"
          :items="dataTable.data"
          :expanded.sync="expanded"
          item-key="contract.objectId"
          class="elevation-1 v-data-table-report data-table-invoice"
          :footer-props="{
            'items-per-page-options': [20, 50, 100, -1],
          }"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')"
        >
          <template v-slot:header.contract.market.name="{ header }">
            <div class="text-nowrap-table market-name " style="min-width:150px;">{{ header.text }}</div>
          </template>

          <template v-slot:header.contract.customer.fullName="{ header }">
            <div class="text-nowrap-table market-name " style="min-width:180px;">{{ header.text }}</div>
          </template>

          <template v-slot:header.contract.businessName="{ header }">
            <div class="text-nowrap-table business-name " style="min-width:100px;">{{ header.text }}</div>
          </template>

          <template v-slot:header.contractAreas="{ header }">
            <div class="text-nowrap-table area-name " style="min-width:140px;">{{ header.text }}</div>
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <template v-for="item, index in items" >
                <tr :key="index">
                  <td class="hd-resize">
                    <div v-if="item.contract && item.contract.market" class="text-truncate text-center">
                      {{ item.contract.market.name || "" }}
                    </div>
                  </td>
                  <td class="hd-resize">
                    <div v-if="item.contract && item.contract.customer" class="text-truncate text-center">
                      {{ item.contract.customer.fullName || "" }}
                    </div>
                  </td>
                  <td>
                    <div v-if="item.contract" class="text-no-wrap">{{ item.contract.contractId || "" }} </div>
                  </td>
                  <td class="hd-resize">
                    <div v-if="item.contract && item.contract.businessName" class="text-truncate">
                      {{ item.contract.businessName || "" }}
                    </div>
                  </td>
                  <td class="hd-resize">
                    <div class="text-truncate">{{item.contract.areas.map(d => d.name).join(",")}} </div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.totalDeposit > 0">
                      {{ item.totalDeposit | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.totaltotalUnpaid > 0">
                      {{ item.totaltotalUnpaid | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div
                      v-if="item.totalDeposit - item.totaltotalUnpaid"
                      :class="`number-nowrap ${item.totalDeposit - item.totaltotalUnpaid >= 0 ? 'success--text' : 'error--text'}`" 
                    >
                      {{ (item.totalDeposit - item.totaltotalUnpaid) | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.totalNotDue > 0">
                      {{ item.totalNotDue | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total30Day > 0">
                      {{ item.total30Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total60Day > 0">
                      {{ item.total60Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total90Day > 0">
                      {{ item.total90Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total120Day > 0">
                      {{ item.total120Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total150Day > 0">
                      {{ item.total150Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.total180Day > 0">
                      {{ item.total180Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <div class="number-nowrap" v-if="item.totalGreaterThan180Day > 0">
                      {{ item.totalGreaterThan180Day | currencyPrefixSign }}
                    </div>
                    <div class="text-center" v-else>-</div>
                  </td>
                  <td>
                    <v-btn small icon @click="item.isExpand = !item.isExpand">
                      <v-icon v-if="item.isExpand">mdi-chevron-up</v-icon>
                      <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <template v-if="item.isExpand">
                  <tr v-for="report, rIndex in item.items" :key="`${index}-${rIndex}`">
                    <td :colspan="5" class="text-center">
                      <a v-if="report.invoice" @click="showInvoice(report.invoice)">{{ report.invoice.documentId }}</a>
                      <a v-if="report.receipt" @click="showReceipt(report.receipt)">{{ report.receipt.documentId }}</a>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.totalDeposit > 0">
                        {{ report.totalDeposit | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.totaltotalUnpaid > 0">
                        {{ report.totaltotalUnpaid | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="text-center">-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.totalNotDue > 0">
                        {{ report.totalNotDue | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total30Day > 0">
                        {{ report.total30Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total60Day > 0">
                        {{ report.total60Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total90Day > 0">
                        {{ report.total90Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total120Day > 0">
                        {{ report.total120Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total150Day > 0">
                        {{ report.total150Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.total180Day > 0">
                        {{ report.total180Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td>
                      <div class="number-nowrap" v-if="report.totalGreaterThan180Day > 0">
                        {{ report.totalGreaterThan180Day | currencyPrefixSign }}
                      </div>
                      <div class="text-center" v-else>-</div>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              <tr class="font-bold">
                <td colspan="5" class="text-center">{{ $t('sum') }}</td>
                <td>
                  <div class="number-nowrap" v-if="summary.totalDeposit > 0">{{ summary.totalDeposit | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap text-bold" v-if="summary.totaltotalUnpaid > 0">{{ summary.totaltotalUnpaid | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div
                    v-if="summary.totalDiff"
                    :class="`number-nowrap ${summary.totalDiff >= 0 ? 'success--text' : 'error--text'}`" 
                  >
                    {{ summary.totalDiff | currencyPrefixSign }}
                  </div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.totalNotDue > 0">{{ summary.totalNotDue | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total30Day > 0">{{ summary.total30Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total60Day > 0">{{ summary.total60Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total90Day > 0">{{ summary.total90Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total120Day > 0">{{ summary.total120Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total150Day > 0">{{ summary.total150Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.total180Day > 0">{{ summary.total180Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>
                  <div class="number-nowrap" v-if="summary.totalGreaterThan180Day > 0">{{ summary.totalGreaterThan180Day | currencyPrefixSign }}</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td class="non-print"></td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-card class="d-flex justify-center py-10" v-if="isLoading">
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
			</template>
		</Layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <InvoiceDialog
      v-model="isInvoiceDialog"
      :invoiceId="tempInvoiceId"
      :projectId="projectId"
    />
    <ReceiptDialog
      v-model="isReceiptDialog"
      :receiptId="tempReceiptId"
      :projectId="projectId"
    />
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import InvoiceDialog from "@/components/InvoiceDialog.component";
import ReceiptDialog from "@/components/ReceiptDialog.component";
import { Contract, Invoice, Receipt } from "../../classes"
import { ExportMarketReport } from "../../exports";
export default {
	components: {
		Layout,
    InvoiceDialog,
    ReceiptDialog
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
			isLoading: false,
			isError: false,
      hashReport: {},
      expanded: [],
      isInvoiceDialog: false,
      tempInvoiceId: null,
      isReceiptDialog: false,
      tempReceiptId: null,
      summary:{},
      invoices: null,
      receipts: null,
			dataTable: {
				header: [
          {
            text: this.$t('market.market'),
            value: "contract.market.name",
            align:"center",
            class: "custom-sort"
          },
          {
            text: this.$t('market.marchant_name'),
            value: "contract.customer.fullName",
            align: "center",
            width: "15%",
            sortable: false,
          },
					{
            text: this.$t('contract.contract_number_only'),
            value: "contract.contractId",
            align:"center",
          },
          {
            text: this.$t('area.shop_name'),
            value: "contract.businessName",
            align:"center",
            sortable: false,
          },
          {
            text: this.$t('contract.contract_in_area'),
            value: "contractAreas",
            align:"center",
            class: "custom-sort"
          },
					{
            text: this.$t('deposit'),
            align: "right",
            value: "totalDeposit"
          },
					{
            text: this.$t('invoice.total_pending_invoice'),
            align: "right",
            value: "totaltotalUnpaid"
          },
          {
            text: this.$t('income.difference'),
            align: "right",
            value: "totalDiff"
          },
					{
            text: this.$t('payment.not_due'),
            align: "right",
            value: "totalNotDue"
          },
          {
            text: this.$t('payment.pending_payment_one_to_thirty_days'),
            align: "right",
            value: "total30Day"
          },
          {
            text: this.$t('payment.pending_payment_thirty_one_to_sixty_days'),
            align: "right",
            value: "total60Day"
          },
          {
            text: this.$t('payment.pending_payment_sixty_one_to_ninety_days'),
            align: "right",
            value: "total90Day"
          },
          {
            text: this.$t('payment.pending_payment_ninety_one_to_one_hundred_twenty_days'),
            align: "right",
            value: "total120Day"
          },
          {
            text: this.$t('payment.pending_payment_one_hundred_twenty_one_to_one_hundred_fifty_days'),
            align: "right",
            value: "total150Day"
          },
          {
            text: this.$t('payment.pending_payment_one_hundred_fifty_one_to_one_hundred_eighty_days'),
            align: "right",
            value: "total180Day"
          },
          {
            text: this.$t('payment.pending_payment_more_than_one_hundred_eighty_days'),
            align: "right",
            value: "totalGreaterThan180Day"
          },
          { text: '', sortable: false },
				],
        data: []
			}
    }
  },
	created(){
		this.initData()
	},
	methods: {
		async initData(){
			this.isLoading = true
			try {
        let params = {
          projectId: this.projectId,
          isToMainCurrency: true,
          isRaw: true
        }
        this.invoices = await this.$helper.queryMore(Invoice.getUnpaidInvoicesByProject, params)
        let contractIds = [...new Set(this.invoices.map(d => d.contract?.objectId))]
        this.receipts = []
        let chunks = this.$helper.splitArrayIntoChunks(contractIds, 500)
        for(let chunk of chunks){
          let receipts = await Receipt.getDepositReceiptsByContracts({
            contractIds: chunk,
            isToMainCurrency: true,
            isRaw: true
          })
          this.receipts = [
            ...this.receipts,
            ...receipts
          ]
        }
        this.prepareData()
				this.isLoading = false
			} catch(error) {
				this.isLoading = false
				this.isError = true
			}
		},
    prepareData(){
      this.summary = {
        totalNotDue: 0,
        total30Day: 0,
        total60Day: 0,
        total90Day: 0,
        total120Day: 0,
        total150Day: 0,
        total180Day: 0,
        totalGreaterThan180Day: 0,
        totaltotalUnpaid: 0,
        totalDeposit: 0,
        totalDiff: 0
      }
      for(let invoice of this.invoices){
        if(invoice.contract && invoice.contract.objectId){
          let contract =  new Contract(invoice.contract)
          let contractId = contract.objectId
          let data = {
            totalNotDue: 0,
            total30Day: 0,
            total60Day: 0,
            total90Day: 0,
            total120Day: 0,
            total150Day: 0,
            total180Day: 0,
            totalGreaterThan180Day: 0,
            totaltotalUnpaid: invoice.totalUnpaidValue,
            invoice: invoice,
            contract: contract
          }
          let difDay = this.$moment(new Date()).startOf('day').diff(this.$moment(invoice.dueDate).startOf('day'), "days");
          let unpaid = invoice.totalUnpaidValue || 0
          if(difDay <= 0) data.totalNotDue = unpaid
          else if(difDay <= 30) data.total30Day = unpaid
          else if(difDay <= 60) data.total60Day = unpaid
          else if(difDay <= 90) data.total90Day = unpaid
          else if(difDay <= 120) data.total120Day = unpaid
          else if(difDay <= 150) data.total150Day = unpaid
          else if(difDay <= 180) data.total180Day = unpaid
          else data.totalGreaterThan180Day = unpaid

          if(!this.hashReport[contractId]){
            this.hashReport[contractId] = {
              totalNotDue: 0,
              total30Day: 0,
              total60Day: 0,
              total90Day: 0,
              total120Day: 0,
              total150Day: 0,
              total180Day: 0,
              totalGreaterThan180Day: 0,
              totaltotalUnpaid: 0,
              totalDeposit: 0,
              items: [],
              contract: contract,
              isExpand: false,
            }
          }

          this.hashReport[contractId].totalNotDue += data.totalNotDue
          this.hashReport[contractId].total30Day += data.total30Day
          this.hashReport[contractId].total60Day += data.total60Day
          this.hashReport[contractId].total90Day += data.total90Day
          this.hashReport[contractId].total120Day += data.total120Day
          this.hashReport[contractId].total150Day += data.total150Day
          this.hashReport[contractId].total180Day += data.total180Day
          this.hashReport[contractId].totalGreaterThan180Day += data.totalGreaterThan180Day
          this.hashReport[contractId].totaltotalUnpaid += data.totaltotalUnpaid

          this.hashReport[contractId].items.push(data)

          this.summary.totalNotDue += data.totalNotDue;
          this.summary.total30Day += data.total30Day;
          this.summary.total60Day += data.total60Day;
          this.summary.total90Day += data.total90Day;
          this.summary.total120Day += data.total120Day;
          this.summary.total150Day += data.total150Day;
          this.summary.total180Day += data.total180Day;
          this.summary.totalGreaterThan180Day += data.totalGreaterThan180Day;
          this.summary.totaltotalUnpaid += data.totaltotalUnpaid;
        }
      }
      for(let receipt of this.receipts){
        if(receipt.contract && receipt.contract.objectId){
          let contract =  new Contract(receipt.contract)
          let contractId = contract.objectId
          let data = {
            totalNotDue: 0,
            total30Day: 0,
            total60Day: 0,
            total90Day: 0,
            total120Day: 0,
            total150Day: 0,
            total180Day: 0,
            totalGreaterThan180Day: 0,
            totaltotalUnpaid: 0,
            totalDeposit: receipt.totalValue,
            receipt: receipt,
            contract: this.hashReport[contractId] ? this.hashReport[contractId].contract : contract
          }

          this.hashReport[contractId].totalDeposit += receipt.totalValue
          this.hashReport[contractId].items.push(data)

          this.summary.totalDeposit += receipt.totalValue;
        }
      }
      this.summary.totalDiff = this.summary.totalDeposit - this.summary.totaltotalUnpaid
      this.dataTable.data = []
      for(let key in this.hashReport){
        this.dataTable.data.push(this.hashReport[key])
      }
    },
    showInvoice(invoice){
      this.tempInvoiceId = invoice.objectId
      this.isInvoiceDialog = true
    },
    showReceipt(receipt){
      this.tempReceiptId = receipt.objectId
      this.isReceiptDialog = true
    },
    async exportExcel(){
      this.isLoading = true
      try{
        let items = []
        for(let key in this.hashReport){
          items = [
            ...items,
            ...this.hashReport[key].items
          ]
        }
        await ExportMarketReport.exportMarketReportByProject(items, this.summary)
        this.isLoading = false
      }catch(error){
        this.isLoading = false
        this.isError = true
      }
    }
	}
}
</script>
<style>
.v-data-table__expanded__content {
  box-shadow: 0 0 3px inset !important;
}
</style>

<style lang="scss" scoped>
.contract-areas {
  text-align: center;
  display: none;

  @media print {
    display: block;
  }
}

.data-table-invoice::v-deep td {
  max-width: 250px;
  min-width: 50px;
}


.data-table-invoice::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-invoice::v-deep td.hd-resize.area-name {
  max-width: 80px;
}

.data-table-invoice::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
.text-right {
  white-space: nowrap;
}
</style>